
import { defineComponent } from "vue";
import Grid from "@moonlight/vue3/components/Grid.vue";
import PageTitle from "@/components/common/PageTitle.vue";
import { trans } from "@/globals/translator";
import Button from "@moonlight/vue3/components/Button.vue";
import { useRoute } from "vue-router";
import useAuthUser from "@/composables/useAuthUser";
import Loading from "@/components/common/Loading.vue";

export default defineComponent({
  components: {
    Grid,
    PageTitle,
    Button,
    Loading,
  },
  setup() {
    const route = useRoute();
    const { authUser, isFetchingAuthUser } = useAuthUser();

    const redirect = route.query.r ?? process.env.VUE_APP_SITE_URL;
    const loginLink =
      process.env.VUE_APP_FILMIN_WEB_LOGIN_LINK +
      "&r=" +
      encodeURIComponent(redirect as string) +
      "&context=press";
    const codeLink = process.env.VUE_APP_FILMIN_WEB_CODE_LINK;
    return {
      loginLink,
      trans,
      authUser,
      isFetchingAuthUser,
      codeLink,
    };
  },
});
